/**
 * Preselección de plan desde la landing (NER-3148).
 *
 * La landing Resto (nerdo.solutions/resto) tiene CTAs que apuntan a
 * `/resto/admin/register?plan=starter|professional|business|enterprise`.
 * RegisterPage lee ese `?plan=X`, lo normaliza/valida con estos helpers y lo
 * persiste en sessionStorage; el OnboardingWizard lo consume para preseleccionar
 * la card correcta en el paso de elección de plan.
 */

// Planes internos válidos (deben matchear los planId que devuelve getPlans()).
export const VALID_PLAN_IDS = ['free', 'starter', 'professional', 'business', 'enterprise'];

// Mapeo de ids de la landing (ES) → ids internos.
export const LANDING_PLAN_MAP = { profesional: 'professional' };

/**
 * Normaliza y valida el valor crudo del query `?plan=X`.
 * @param {string|null|undefined} raw valor tal cual viene de la URL
 * @returns {string|null} planId interno válido, o null si es inválido/ausente
 */
export function resolvePreselectedPlanId(raw) {
  if (!raw) return null;
  const normalized = String(raw).trim().toLowerCase();
  const planId = LANDING_PLAN_MAP[normalized] || normalized;
  return VALID_PLAN_IDS.includes(planId) ? planId : null;
}

/**
 * Resuelve qué planId debe quedar preseleccionado en el wizard.
 * Orden de preferencia: plan de la landing (si existe en la lista) →
 * professional → primer plan disponible → null.
 * @param {Array<{planId: string}>} sortedPlans planes ordenados
 * @param {string|null} preselectedPlanId planId consumido de sessionStorage
 * @returns {string|null}
 */
export function resolveInitialPlanId(sortedPlans, preselectedPlanId) {
  const plans = Array.isArray(sortedPlans) ? sortedPlans : [];
  const preselected = preselectedPlanId
    ? plans.find((p) => p.planId === preselectedPlanId)
    : null;
  const professional = plans.find((p) => p.planId === 'professional');
  const initial = preselected || professional;
  return initial ? initial.planId : plans[0]?.planId || null;
}
